<template>
	<div>
		<template v-if="editable">
			<a
				@click.prevent="trigger = !trigger"
				class="avatar-container mx-auto d-table position-relative"
			>
				<b-avatar
					v-if="initialsOnly"
					:text="userInitials"
					:size="size"
				></b-avatar>
				<b-avatar v-else :src="avatarUrl" :size="size"></b-avatar>

				<span
					v-if="editable"
					class="avatar-upload position-absolute w-100 h-100 top-0 left-0 d-flex align-items-center justify-content-center"
				>
					<strong class="text-center">
						<b-icon icon="pencil-square" scale="1"></b-icon>
						<span class="d-block">Edit Photo</span>
					</strong>
				</span>
			</a>

			<b-link
				v-if="src"
				@click.prevent="deleteAvatar"
				class="mt-3 text-danger text-center small d-block"
				>Delete {{ label }}</b-link
			>

			<p v-if="status" class="mt-3 mb-0 text-xs font-italic text-center">
				{{ status }}
			</p>
			<avatar-cropper
				:trigger="trigger"
				:labels="labels"
				@uploading="uploading"
				@uploaded="uploaded"
				@error="error"
				:upload-url="request.url"
				:upload-file-field="isCompany ? 'logo' : 'profile_photo'"
				:request-options="request.options"
			/>
		</template>
		<template v-else>
			<b-avatar
				v-if="initialsOnly"
				:text="userInitials"
				:size="size"
			></b-avatar>
			<b-avatar v-else :src="avatarUrl" :size="size"></b-avatar>
		</template>
	</div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";

export default {
	name: "base-avatar",
	props: {
		initialsOnly: Boolean,
		editable: {
			type: Boolean,
			default: true,
		},
		src: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: "Avatar",
		},
		size: {
			type: String,
			default: "17rem",
		},
		isCompany: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		"avatar-cropper": AvatarCropper,
	},
	inject: ["memberSvc", "profileSvc"],
	data() {
		return {
			trigger: false,
			labels: {
				submit: "Upload",
				cancel: "Cancel",
			},
			status: null,
		};
	},
	computed: {
		userInitials() {
			return this.$user
				.get()
				.first_name.split(" ")
				.map((item) => {
					return item.split("")[0];
				})
				.join("");
		},
		avatarUrl() {
			return (
				this.src ||
				(this.isCompany
					? `/img/defaults/company_default.png`
					: `/img/defaults/profile_default.png`)
			);
		},
		request() {
			return {
				url: this.isCompany
					? `${process.env.VUE_APP_BACKEND_URL}/api/v1/company/logo/${this.profileSvc.user.company.id}/`
					: `${process.env.VUE_APP_BACKEND_URL}/api/v1/user/profile/pic/${this.profileSvc.user.id}/`,
				options: {
					method: "PUT",
					headers: {
						Authorization: `JWT ${
							localStorage.getItem("accessToken") || null
						}`,
					},
				},
			};
		},
	},
	methods: {
		uploading() {
			this.status = "Uploading...";
		},
		uploaded({ response }) {
			if (200 == response.status) {
				this.$emit("avatar-uploaded");

				this.status = null;

				this.$toasted.show(
					`${
						this.isCompany ? "Logo" : "Profile photo"
					} updated successfully.`
				);
			}
		},
		error({ type }) {
			if ("upload" == type)
				this.$toasted.show(
					`${
						this.isCompany ? "Logo" : "Profile photo"
					} upload failed.`,
					"error"
				);
		},
		async deleteAvatar() {
			if (!this.editable) return false;

			if (this.isCompany)
				await this.memberSvc.deleteLogo(this.profileSvc.user.company);
			else await this.profileSvc.deleteAvatar(this.profileSvc.user);

			this.$emit("avatar-deleted");

			this.$toasted.show("Avatar deleted successfully.");
		},
	},
};
</script>
